import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Eyebrow = ({ label, dark = false, className = '' }) => (_jsxs("div", { className: `eyebrow ${className}`, children: [_jsx("span", { className: `eyebrow-diamond ${dark ? '!bg-citron' : ''}` }), _jsx("span", { className: `eyebrow-label ${dark ? '!text-citron' : ''}`, children: label })] }));
export default Eyebrow;
